<template>
  <div class="driftsmeldinger ods-padding-bottom-5">
    <div v-if="loading">
      <ods-spinner />
      {{ $t('driftsmeldinger.loading') }}
    </div>
    <ods-status-message
      v-else-if="driftsmeldinger.error"
      tittel="Melding om advarsel"
      :melding="driftsmeldinger.error"
      meldingstype="warning"
    />
    <template v-else>
      <ods-status-message
        v-for="melding in driftsmeldinger"
        :key="melding.tittel"
        :tittel="melding.tittel"
        :melding="melding.melding"
        :meldings-dato="getDate(new Date(melding.meldingsdato))"
        :meldingstype="melding.meldingstype"
      />
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import OdsDateTime from '@oslokommune/oslo-designsystem/src/general/helpers/date_and_time/date_and_time';
import apiClient from '@/api/ApiClient';
import OdsSpinner from '@/global-components/OdsSpinner.vue';
import OdsStatusMessage from '@/global-components/OdsStatusMessage.vue';

export default {
  name: 'SystemNotification',

  components: {
    OdsSpinner,
    OdsStatusMessage,
  },

  props: {
    komponentId: {
      type: String,
      required: true,
    },
  },

  data: () => ({
    driftsmeldinger: {},
    loading: false,
  }),

  computed: {
    ...mapState('representasjoner', ['currentRepresentation']),
  },

  watch: {
    currentRepresentation: {
      immediate: true,
      handler() {
        this.getDriftsmeldinger();
      },
    },
  },

  methods: {
    async getDriftsmeldinger() {
      this.loading = true;

      try {
        const { driftsmeldingDtoListe } = await apiClient.getDriftsmeldinger(this.komponentId);
        if (!driftsmeldingDtoListe) throw Error();
        this.driftsmeldinger = driftsmeldingDtoListe;
      } catch {
        const error = this.$t('driftsmeldinger.error', { id: this.komponentId });
        this.driftsmeldinger = { error };
      }

      this.loading = false;
    },

    getDate(dato) {
      return OdsDateTime.format(dato, null, { format: 'daytime', time: { prefix: ', kl. ' } }, {});
    },
  },
};
</script>
